/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NpiResponseEnumerationType } from './NpiResponseEnumerationType';
import {
    NpiResponseEnumerationTypeFromJSON,
    NpiResponseEnumerationTypeFromJSONTyped,
    NpiResponseEnumerationTypeToJSON,
    NpiResponseEnumerationTypeToJSONTyped,
} from './NpiResponseEnumerationType';

/**
 * 
 * @export
 * @interface ValidatePalNpiResponse
 */
export interface ValidatePalNpiResponse {
    /**
     * 
     */
    found: boolean;
    /**
     * 
     */
    npi: string;
    /**
     * 
     */
    enumeration_type?: NpiResponseEnumerationType;
}



/**
 * Check if a given object implements the ValidatePalNpiResponse interface.
 */
export function instanceOfValidatePalNpiResponse(value: object): value is ValidatePalNpiResponse {
    if (!('found' in value) || value['found'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    return true;
}

export function ValidatePalNpiResponseFromJSON(json: any): ValidatePalNpiResponse {
    return ValidatePalNpiResponseFromJSONTyped(json, false);
}

export function ValidatePalNpiResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatePalNpiResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'found': json['found'],
        'npi': json['npi'],
        'enumeration_type': json['enumeration_type'] == null ? undefined : NpiResponseEnumerationTypeFromJSON(json['enumeration_type']),
    };
}

export function ValidatePalNpiResponseToJSON(json: any): ValidatePalNpiResponse {
    return ValidatePalNpiResponseToJSONTyped(json, false);
}

export function ValidatePalNpiResponseToJSONTyped(value?: ValidatePalNpiResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'found': value['found'],
        'npi': value['npi'],
        'enumeration_type': NpiResponseEnumerationTypeToJSON(value['enumeration_type']),
    };
}

